import { frameRate } from "../babylonScene";
import { mobileOrNot } from "../helpers/mobileDetect";

let alreadyLoaded = {
  bunker: false,
  locker: false,
};

const sweepAnimation = (options) => {
  options = options || {};
  const {clockwise, startingPoint} = options; 
  // suunta määrrittyy clockwise-parametrissä
  // bunkerilla oma animaatio, muut käyttää tätä
  // Nopeutin keyframeja jakamalla ne kolmella, voidaan säätää joskus
  const sweep = new BABYLON.Animation(
    "sweep",
    "rotation.y",
    frameRate,
    BABYLON.Animation.ANIMATIONTYPE_FLOAT,
    BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
  );

  let sweep_keys = [];

  sweep_keys.push({
    frame: 0,
    value: startingPoint ?? 0,
  });

  sweep_keys.push({
    frame: (1 / 6) * frameRate,
    value: startingPoint ?? 0,
  });

  sweep_keys.push({
    frame: (7 / 6) * frameRate,
    value: Math.PI / (clockwise ? -3 : 3),
  });

  sweep_keys.push({
    frame: (15 / 6) * frameRate,
    value: Math.PI / (clockwise ? -1.3 : 1.3),
  });

  sweep.setKeys(sweep_keys);
  return sweep;
};

const bunkerDoor = async (scene) => {
  //warehouse-bunker metalliovi




  const animation = async (bunkerDoor) => {
    // const clock = scene.getMeshByName("Huone2_lukkokonsoli");
    // console.log(bunkerDoor)
    const euler = bunkerDoor.rotationQuaternion.toEulerAngles();
    bunkerDoor.rotation = new BABYLON.Vector3(euler.x, euler.y, euler.z);
    bunkerDoor.visibility = 1;
    bunkerDoor.checkCollisions = true;
    //bunkerDoor.addChild(clock);
    //bunkerDoor.addChild(warehousePuzzle4);

    var sweepBunk = new BABYLON.Animation(
      "sweepBunk",
      "rotation.y",
      frameRate,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );

    var sweepBunk_keys = [];

    sweepBunk_keys.push({
      frame: 0,
      value: 0,
    });

    sweepBunk_keys.push({
      frame: 1 * frameRate,
      value: 0,
    });

    sweepBunk_keys.push({
      frame: 5 * frameRate,
      value: Math.PI / -3,
    });

    sweepBunk_keys.push({
      frame: 8 * frameRate,
      value: Math.PI / -2,
    });
    /*
  sweepBunk_keys.push({
    frame: 20 * frameRate,
    value: Math.PI/-2
  });
  */

    sweepBunk.setKeys(sweepBunk_keys);

    const open = () => {
      scene.beginDirectAnimation(
        bunkerDoor,
        [sweepBunk],
        0,
        25 * frameRate,
        false
      );

    }
    
    alreadyLoaded.bunker = open;
    return open;
  };

  // alreadyLoaded.bunker = result;

  return await animation(scene.getMeshByName("H2_Bunkkerin_ovi"));
  //return await animation(result.meshes[1]);
};

const flatExitDoor = async (scene) => {
  const animation = async (exitDoor) => {
    if (exitDoor.rotationQuaternion) {
      const euler = exitDoor.rotationQuaternion.toEulerAngles();
      exitDoor.rotation = new BABYLON.Vector3(euler.x, euler.y, euler.z);
    }
    exitDoor.visibility = 1;
    exitDoor.checkCollisions = true;
    const sweep = sweepAnimation({clockwise: true});
    return () =>
      scene.beginDirectAnimation(exitDoor, [sweep], 0, 25 * frameRate, false);
  };

  return await animation(scene.getMeshByName("H1_Ulko_ovi"));
};

const cameraLockerDoor = async (scene) => {
  var cameraLockerHinge = BABYLON.MeshBuilder.CreateBox(
    "hinge_locker",
    { height: 6, width: 2, depth: 15, updatable: false, text: true },
    scene
  );
  cameraLockerHinge.visibility = 0;
  //cameraLockerHinge.position = new BABYLON.Vector3(123.5, 3, -197);
  cameraLockerHinge.checkCollisions = true;

  const animation = async (door) => {
    door.rotation = new BABYLON.Vector3(-11, 0, 0);
    if(mobileOrNot()) {
      const cameraLockerDoor = scene.getMeshByName("H2_Kamerakaappi_ovi")
      cameraLockerDoor.rotation.x = 4.735078260660616;
    }
    door.visibility = 1;
    // door.addChild(cameraLockerHinge);

    var sweepLocker = new BABYLON.Animation(
      "sweepLocker",
      "rotation.y",
      frameRate,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    );

    var sweepLocker_keys = [];

    sweepLocker_keys.push({
      frame: 0,
      value: 0,
    });

    sweepLocker_keys.push({
      frame: 1 * frameRate,
      value: Math.PI / 2.8,
    });

    sweepLocker_keys.push({
      frame: 2 * frameRate,
      value: Math.PI / 1.8,
    });

    sweepLocker_keys.push({
      frame: 3 * frameRate,
      value: Math.PI / 0.9,
    });
    /*
  sweepLocker_keys.push({
    frame: 20 * frameRate,
    value: Math.PI/-2
  });
  */

    sweepLocker.setKeys(sweepLocker_keys);

    const opening = () =>
      scene.beginDirectAnimation(door, [sweepLocker], 0, 25 * frameRate, false);
    alreadyLoaded.locker = opening;
    return opening;
  };

  //window.openLocker = await animation(result.meshes[1])
  return await animation(scene.getMeshByName("H2_Kamerakaappi_ovi"));
};

const corridorWarehouse = async (scene) => {
  //corridor-warehouse metalliovi


  const animation = async (metalDoorWarehouse) => {
    if (metalDoorWarehouse.rotationQuaternion) {
      const euler = metalDoorWarehouse.rotationQuaternion.toEulerAngles();
      metalDoorWarehouse.rotation = new BABYLON.Vector3(
        euler.x,
        euler.y,
        euler.z
      );
    }
    metalDoorWarehouse.visibility = 1;
    metalDoorWarehouse.checkCollisions = true;    

    const sweep = sweepAnimation();

    return () => {
      scene.getMeshByName("H1_Varaston_ovi").position.z = -95.983
      scene.beginDirectAnimation(
        metalDoorWarehouse,
        [sweep],
        0,
        25 * frameRate,
        false
      );
    }
  };

  // const result = await BABYLON.SceneLoader.ImportMeshAsync(
  //   ["Huone1_turvaovi_ovi"],
  //   window.pakopeliPublicAssetUrl + "assets/",
  //   "level_corridor_warehouse_metaldoor.glb",
  //   scene
  // );
  //result.meshes[1].alwaysSelectAsActiveMesh = true
  return await animation(scene.getMeshByName("H1_Varaston_ovi"));
};

const flatCorridor = async (scene, frameRate) => {
  var doorWoodHinge = BABYLON.MeshBuilder.CreateBox(
    "hinge",
    { height: 6, width: 10, depth: 0.8, updatable: false, text: true },
    scene
  );
  doorWoodHinge.visibility = 0;
  doorWoodHinge.alwaysSelectAsActiveMesh = true;
  doorWoodHinge.position = new BABYLON.Vector3(64, 7, -51.3);
  doorWoodHinge.checkCollisions = true;

  const animation = async (doorWood) => {
    if (doorWood.rotationQuaternion) {
      const euler = doorWood.rotationQuaternion.toEulerAngles();
      doorWood.rotation = new BABYLON.Vector3(euler.x, euler.y, euler.z);
      scene.getMeshByName("H1_Valiovi").rotation.y = 0.18849555921538758
      scene.getMeshByName("H1_Valiovi").position.z = -51.519
    }
    //   doorWood.rotation = new BABYLON.Vector3(0, 0, 0);
    doorWood.visibility = 1;
    doorWood.addChild(doorWoodHinge);



    const sweep = sweepAnimation({startingPoint: scene.getMeshByName("H1_Valiovi").rotation.y});
    return () =>
      scene.beginDirectAnimation(doorWood, [sweep], 0, 25 * frameRate, false);
  };

  /*   const result = await BABYLON.SceneLoader.ImportMeshAsync(
    ["huone1_ovi_sisa_ovi"],
    window.pakopeliPublicAssetUrl + "assets/",
    "level_flat_inner_door_v0.83c.glb",
    scene
  ); */



  return await animation(scene.getMeshByName("H1_Valiovi"));
};

const flatDoors = async (scene, frameRate) => {
  return {
    openFlatCorridor: await flatCorridor(scene, frameRate),
    openWarehouse: await corridorWarehouse(scene, frameRate),
    openExit: await flatExitDoor(scene, frameRate),
  };
};

const warehouseDoors = async (scene, frameRate) => {
  return {
    openBunker: alreadyLoaded.bunker
      ? alreadyLoaded.bunker
      : await bunkerDoor(scene, frameRate),
    openLocker: alreadyLoaded.locker
      ? alreadyLoaded.locker
      : await cameraLockerDoor(scene, frameRate),
  };
};
export { flatDoors, warehouseDoors };
